interface SummaryProps {
  summary: {
    title: string;
    value: string;
    description?: string;
  }[];
  highlight?: boolean;
}

const Summary: React.FC<SummaryProps> = ({ summary, highlight = true }) => (
  <div className="flex flex-col gap-4 md:max-w-xl">
    <div className="flex flex-col gap-2 border border-border-secondary rounded-3xl bg-surface-base shadow-sm">
      <div className="flex flex-col">
        {summary.map((item, index) => (
          <div key={item.title} className={`grid grid-cols-[1fr,1fr,1fr] gap-x-4 px-6 py-4 border-b border-border-secondary ${index === summary.length - 1 ? 'border-b-0 rounded-b-3xl' : ''} ${index === summary.length - 1 && highlight ? 'bg-surface-secondary' : ''}`}>
            <h2 className="text-sm font-medium">{item.title}</h2>
            <p className="text-sm">{item.value}</p>
            {item.description ? (
              <p className="text-xs text-text-tertiary">{item.description}</p>
            ) : (
              <div></div>
            )}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Summary;
